import type { SxProps, Theme } from "@mui/material/styles";
import { logSpecsModelPath } from "../specsModelPathLogger";

export type DebugLabelProps = {
  onClick?: () => void;
  sx?: SxProps<Theme>;
};

export function getDebugLabelProps(debugPath?: string): DebugLabelProps {
  if (!debugPath) {
    return {};
  }

  return {
    onClick: () => logSpecsModelPath(debugPath),
  } satisfies DebugLabelProps;
}

export function formatClickToEditValue(value: unknown) {
  if (Array.isArray(value)) {
    return value.join(", ");
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }

  if (value == null) {
    return "";
  }

  return String(value);
}
